import React, { useContext, useState } from "react";
import { Box, Stack, Tab, Tabs, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomerReports from "./CustomerReports";


type CustomerReporTabProps = {
    raId: string,
    raState: string
}

export default function CustomerReportTab(props: CustomerReporTabProps) {
    const theme = useTheme();
    const { t } = useTranslation(['network', 'translation']);

    const [activeTabValue, setActiveTabValue] = useState(0);

    const handleChangeActiveTab = (e: React.SyntheticEvent, activeTab: number) => {
        e.stopPropagation();

        setActiveTabValue(activeTab);
    };

    //scenario: 1 = Check-Out, 2 = Check-In
    return (<>
        <Tabs value={activeTabValue} onChange={handleChangeActiveTab} sx={{ mb: theme.spacing(2) }}>
            <Tab label={t("raDetail.tab.reportcheckout")} value={0} />
            <Tab label={t("raDetail.tab.reportcheckin")} value={1} />
        </Tabs>
        <Stack rowGap={2}>
            {activeTabValue === 0 && <Box role={'tabpanel'}>
                <CustomerReports raId={props.raId} scenario={1} raState={props.raState}/>
            </Box>}
            {activeTabValue === 1 && <Box role={'tabpanel'}>
                <CustomerReports raId={props.raId} scenario={2} raState={props.raState}/>
            </Box>}
        </Stack>
    </>)
}
